export default __webpack_public_path__ + "a4fd7f4c8d9db67ca3fc0c442a795428.png";